/**
 * SettingsLayout — 系统设置外壳：左侧二级菜单（NavLink 路由式）+ 右侧 <Outlet/>。
 * 替代原 SettingsPage 的 useState('team') 单文件 tab 切换 —— 9 个分区拆为 9 个独立路由页
 * （/settings/<id>），各页自管自己的数据/弹窗状态。菜单项 → 二级路由一一对应。
 */

import { NavLink, Outlet } from 'react-router-dom';
import { Icons } from '~/lib/icons';

interface SettingsNavItem {
  path: string;
  label: string;
  icon: keyof typeof Icons;
}

/** 二级菜单 → 二级路由（顺序即菜单顺序；index 重定向到首项 members）*/
const NAV: SettingsNavItem[] = [
  { path: 'members', label: '团队成员', icon: 'IconUsers' },
  { path: 'roles', label: '角色与权限', icon: 'IconShield' },
  { path: 'audit-logs', label: '操作日志', icon: 'IconHistory' },
  { path: 'regions', label: '地区与语言', icon: 'IconGlobe' },
  { path: 'model-configurations', label: '大模型配置', icon: 'IconCog' },
  { path: 'prohibited-terms', label: '违禁词库', icon: 'IconShield' },
  { path: 'integrations', label: '集成', icon: 'IconBranch' },
  { path: 'webhooks', label: 'Webhooks', icon: 'IconZap' },
  { path: 'notifications', label: '通知策略', icon: 'IconBell' },
  { path: 'advanced', label: '高级', icon: 'IconCog' },
  { path: 'design-system', label: '设计系统', icon: 'IconLayers' },
];

export default function SettingsLayout() {
  return (
    <div
      className="page"
      style={{ display: 'flex', gap: 20, padding: '16px 20px 28px', flexDirection: 'row' }}
    >
      {/* Side nav（路由式：NavLink active 由当前 URL 决定）*/}
      <aside
        style={{ width: 200, flexShrink: 0, position: 'sticky', top: 0, alignSelf: 'flex-start' }}
      >
        <h1 className="page-title" style={{ fontSize: 20, marginBottom: 12 }}>
          系统设置
        </h1>
        <div className="vstack" style={{ gap: 1 }}>
          {NAV.map((t) => {
            const IconC = Icons[t.icon];
            return (
              <NavLink
                key={t.path}
                to={t.path}
                className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
                style={({ isActive }) => ({
                  border: 0,
                  font: 'inherit',
                  textAlign: 'left',
                  width: '100%',
                  cursor: 'pointer',
                  textDecoration: 'none',
                  color: 'inherit',
                  background: isActive ? 'var(--bg-elev)' : 'transparent',
                })}
              >
                <IconC size={14} />
                <span style={{ flex: 1 }}>{t.label}</span>
              </NavLink>
            );
          })}
        </div>
        <div
          style={{ marginTop: 16, padding: 12, background: 'var(--bg-subtle)', borderRadius: 6 }}
        >
          <div className="hstack" style={{ gap: 6, marginBottom: 6 }}>
            <Icons.IconShield size={12} style={{ color: 'var(--info)' }} />
            <span style={{ fontSize: 11.5, fontWeight: 500 }}>合规与审计</span>
          </div>
          <div style={{ fontSize: 11, color: 'var(--fg-muted)', lineHeight: 1.5 }}>
            所有运营操作均记录至 audit log，可在「操作日志」查询。
          </div>
        </div>
      </aside>

      <div style={{ flex: 1, minWidth: 0, display: 'flex', flexDirection: 'column', gap: 14 }}>
        <Outlet />
      </div>
    </div>
  );
}
